// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={(theme) => {
        const themeColors = theme?.palette?.crmTheme || {};
        const cssVars = Object.keys(themeColors).reduce((acc, key) => {
          acc[`--${key}`] = themeColors[key];
          return acc;
        }, {});

        return {
          '*': {
            boxSizing: 'border-box',
          },
          ':root': cssVars,
          html: {
            margin: 0,
            padding: 0,
            width: '100%',
            height: '100%',
            WebkitOverflowScrolling: 'touch',
          },
          body: {
            margin: 0,
            padding: 0,
            width: '100%',
            height: '100%',
          },
          '#root': {
            width: '100%',
            height: '100%',
          },
          input: {
            '&[type=number]': {
              MozAppearance: 'textfield',
              '&::-webkit-outer-spin-button': {
                margin: 0,
                WebkitAppearance: 'none',
              },
              '&::-webkit-inner-spin-button': {
                margin: 0,
                WebkitAppearance: 'none',
              },
            },
          },
          img: {
            display: 'block',
            maxWidth: '100%',
          },
          ul: {
            margin: 0,
            padding: 0,
          },
          // Toast notification styling
          '.Toastify__toast': {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.toast?.fontSize || theme.typography.body2.fontSize,
            fontWeight: theme.typography.toast?.fontWeight || theme.typography.body2.fontWeight,
          },
        };
      }}
    />
  );

  return inputGlobalStyles;
}
